import React, { useContext, useState } from "react";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import { CircularProgress, IconButton } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import { GlobalContext } from "../../context/hoa-global-context";
import { useSelectedTaskStoreStore } from "../../store/useTaskStore";
import propertyTaskService from "../../services/hoa-property-task-service";
import LoadingComponent from "../../components/loading-component/loading-component";
import hoaDatastore from '../../store/hoa-datastore';

const IgnoreIcon = () => {
	const { activeMenu, property, updatePropertyData, changeActiveMenu, updateView } = useContext<any>(GlobalContext);
	if (activeMenu !== "propertiespendingtask") return null;

	const { selectedTask, findDataMatchWithSelectedValueIndex } = useSelectedTaskStoreStore();

	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);

	console.log(selectedTask);

	const handleRemove = async () => {
		setLoading(true);
		setError(null);
		try {
			let propertyTaskId = undefined;
			if (selectedTask?.taskSourceType === "mail") {
				propertyTaskId = selectedTask?.mailDetails?.parsePropertyTaskId;
			} else if (selectedTask?.taskSourceType === "email") {
				propertyTaskId = selectedTask?.emailDetails?.parsePropertyTaskId;
			}

			if (propertyTaskId) {
				await propertyTaskService.deletePropertyTaskById(propertyTaskId);

				const pendingIndex = findDataMatchWithSelectedValueIndex(
					property.data,
					hoaDatastore
				);
				updatePropertyData({
					...property,
					data: property.data.filter(
						(value: any, index: number) => index !== pendingIndex
					),
				});
				changeActiveMenu(activeMenu, false, "", -1);
				updateView("remove-from-list");
				alert("Property Task removed successfully!");
			}
		} catch (error) {
			setError(error.message);
		} finally {
			setLoading(false);
		}
	};

	return (
		<>
			<Tooltip title="Pending Task Ignore">
				<IconButton sx={{ mr: 1 }}>
					<RemoveCircleIcon
						onClick={handleRemove}
						sx={{ cursor: "pointer", fontSize: 30 }}
					/>
				</IconButton>
			</Tooltip>
			<LoadingComponent loading={loading} />
		</>
	);
};

export default IgnoreIcon;
